/**
 * JALRAKSHAK Animation & Intro Experience Controller
 */

export function initAnimations() {
  initPreloaderReveal();
  initScrollObserver();
  initStatCounters();
}

/**
 * 1.2s Fast Branded QR Welcome Splash Reveal
 */
function initPreloaderReveal() {
  const preloader = document.querySelector('.qr-preloader');
  if (!preloader) return;

  // Let the quick progress animation complete smoothly
  setTimeout(() => {
    preloader.classList.add('fade-out');
  }, 1200);
}

/**
 * IntersectionObserver for Smooth Fade-Up on Scroll
 */
function initScrollObserver() {
  const elements = document.querySelectorAll('.animate-on-scroll');
  if (!elements.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  elements.forEach(el => observer.observe(el));
}

/**
 * Animated Number Counters
 */
function initStatCounters() {
  const counters = document.querySelectorAll('.stat-counter-number');
  if (!counters.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const counter = entry.target;
        const target = parseFloat(counter.dataset.target);
        const duration = 1800; // ms
        const startTime = performance.now();
        const isDecimal = target % 1 !== 0;

        function update(currentTime) {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easeOut = 1 - Math.pow(1 - progress, 3);
          const currentVal = easeOut * target;

          counter.textContent = isDecimal ? currentVal.toFixed(1) : Math.floor(currentVal).toLocaleString();

          if (progress < 1) {
            requestAnimationFrame(update);
          } else {
            counter.textContent = isDecimal ? target.toFixed(1) : target.toLocaleString();
          }
        }

        requestAnimationFrame(update);
        observer.unobserve(counter);
      }
    });
  }, { threshold: 0.2 });

  counters.forEach(c => observer.observe(c));
}
